import { render, staticRenderFns } from "./1-select-preset.vue?vue&type=template&id=98b784bc&scoped=true"
import script from "./1-select-preset.vue?vue&type=script&lang=js"
export * from "./1-select-preset.vue?vue&type=script&lang=js"
import style0 from "./1-select-preset.vue?vue&type=style&index=0&id=98b784bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b784bc",
  null
  
)

export default component.exports